<template>
  <JoinAccountForm />
</template>

<script>
  import JoinAccountForm from '../../components/forms/auth/JoinAccount';

  export default {
    components: {
      JoinAccountForm,
    },
  };
</script>
